import { Component, Input, OnInit } from '@angular/core';
import { ProfileService } from 'src/app/_services/profile.service';
import { UtilityService } from 'src/app/_services/utility.service';

@Component({
  selector: 'app-modale-profilo',
  templateUrl: './modale-profilo.component.html',
  styleUrls: ['./modale-profilo.component.css']
})
export class ModaleProfiloComponent implements OnInit {
  @Input() profile: any;
  profileData: any;
  role: string;
  user: any;
  constructor(
    public utilityService: UtilityService,
    private profileService: ProfileService
  ) {}

  async ngOnInit(): Promise<void> {
    this.user = await this.profileService.getUserRoleAsync();
    this.role = this.user.roles[0].name;
  }

  ngOnChanges() {
    if (this.profile) {
      let utility = this.utilityService;
      this.profileData = this.profile[0];
      this.profileData.filestorage.path = utility.getSanitizeUrl(
        this.profileData.filestorage.path
      );

      if (this.profileData.hobbies) {
        this.profileData?.hobbies.forEach(function (hobby: any) {
          hobby.filestorage.path = utility.getSanitizeUrl(
            hobby.filestorage.path
          );

          hobby?.children?.forEach(function (child: any) {
            child.filestorage.path = utility.getSanitizeUrl(
              child.filestorage.path
            );
          });
        });
      }
      if (this.profileData.hobbyunion) {
        this.profileData?.hobbyunion.forEach(function (union: any) {
          union.filestorage.path = utility.getSanitizeUrl(
            union.filestorage.path
          );

          union?.children.forEach(function (child: any) {
            child.filestorage.path = utility.getSanitizeUrl(
              child.filestorage.path
            );
          });
        });
      }

      if (this.profileData.project_user) {
        this.profileData?.project_user.forEach(function (progetti: any) {
          progetti.project.filestorage.path = utility.getSanitizeUrl(
            progetti.project.filestorage.path
          );
        });
      }
    }
  }
}
